import {DataProvider, ResponseBody, ResponseData, ResponseDataProvider, ResponseCodeData} from "@/types";

export default function ResponseDataValue(data, success): ResponseData {
    return {
        data: data,
        success: success,
    }
}

export function ResponseCodeDataValue(data, success, statusCode): ResponseCodeData {
    return {
        data: data,
        success: success,
        statusCode: statusCode
    }
}

export function ResponseDataProviderValue(response: ResponseBody, success): ResponseDataProvider {
    return {
        data: {
            paginationData: {
                currentPage: response.headers['x-pagination-current-page'],
                pageCount: response.headers['x-pagination-page-count'],
                perPage: response.headers['x-pagination-per-page'],
                totalCount: response.headers['x-pagination-total-count'],
            },
            data: response.data
        } as DataProvider,
        success: success,
    }
}

export function ResponseDataProviderWithTotalValue(response: ResponseBody, success): ResponseDataProvider {
    return {
        data: {
            paginationData: {
                currentPage: response.headers['x-pagination-current-page'],
                pageCount: response.headers['x-pagination-page-count'],
                perPage: response.headers['x-pagination-per-page'],
                totalCount: response.headers['x-pagination-total-count'],
            },
            data: response.data.data,
            total: response.data.total
        } as DataProvider,
        success: success,
    }
}
